import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  pointsColor?: string | undefined;
}

const finalPointsColor = (props: IRootProps) => (props.pointsColor ? props.pointsColor : C.DARK_ORANGE);

export const Root = styled.div`
  display: flex;
  width: 100%;
  height: 20px;
  flex-grow: 0;
  padding: 14px 16px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;

export const Loading = styled.div`
  position: relative;
  margin-left: 16px;
  left: -9999px;
  width: 11px;
  height: 11px;
  border-radius: 5px;
  background-color: ${finalPointsColor};
  color: ${finalPointsColor};
  box-shadow: 9999px 0 0 -5px ${finalPointsColor};
  animation: dotPulse 1.5s infinite linear;
  animation-delay: .25s;

  &:before , &:after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    width: 11px;
    height: 11px;
    border-radius: 5px;
    background-color: ${finalPointsColor};
    color: ${finalPointsColor};
  }

  &:before {
    box-shadow: 9984px 0 0 -5px ${finalPointsColor};
    animation: dotPulseBefore 1.5s infinite linear;
    animation-delay: 0s;
  }

  &:after{
    box-shadow: 10014px 0 0 -5px ${finalPointsColor};
    animation: dotPulseAfter 1.5s infinite linear;
    animation-delay: .5s;
  }

  @keyframes dotPulseBefore {
    0% {
      box-shadow: 9984px 0 0 -5px ${finalPointsColor};
    }
    30% {
      box-shadow: 9984px 0 0 2px ${finalPointsColor};
    }
    60%,
    100% {
      box-shadow: 9984px 0 0 -5px ${finalPointsColor};
    }
  }

  @keyframes dotPulse {
    0% {
      box-shadow: 9999px 0 0 -5px ${finalPointsColor};
    }
    30% {
      box-shadow: 9999px 0 0 2px ${finalPointsColor};
    }
    60%,
    100% {
      box-shadow: 9999px 0 0 -5px ${finalPointsColor};
    }
  }

  @keyframes dotPulseAfter {
    0% {
      box-shadow: 10014px 0 0 -5px ${finalPointsColor};
    }
    30% {
      box-shadow: 10014px 0 0 2px ${finalPointsColor};
    }
    60%,
    100% {
      box-shadow: 10014px 0 0 -5px ${finalPointsColor};
    }
  }
`;